export enum InviteToBidToastType {
  SUCCESS,
  FREELANCER_ALREADY_INVITED,
  UNKNOWN_ERROR,
}
